import React, {useRef, useState} from 'react';
import styled, {useTheme} from "styled-components";
import browserHistory from "../utils/history";
import {useSelector} from "react-redux";
import LanguageSelectionList from "./LanguageSelectionList";
import {StyledFooter} from "../resources/styles";
import DisabilityMode from "./DisabilityMode";
import LanguageSelection from "./LanguageSelection";

const CenteredContainer = styled.div`
    display: flex;
    height: ${props => props.theme.footerHeight || "50px" };
        
    div {
        flex: 1;
        text-align: center;
        display: flex;
        justify-content: center;
    }
    box-shadow: ${props => props.theme.footerBoxShadow || "" };
    
    @media print {
        display: none;
    }
`;

const FooterButton = styled.button`
    color: ${props => props.theme.footerColor || "#ffffff" };
    font-size: 40px;
    line-height: normal;
    outline: none;
    opacity: ${props => props.theme.footerIconOpacity || "1" };
    display: flex;
    align-items: center;
`;

const Footer = ({toggleDisabilityMode, disabilityOn, alterMarginTop}) => {
    const theme = useTheme();
    const footerType = useSelector(state => state.navigation.footerType);
    const enableDisabilityMode = useSelector(state => state.configuration?.hubSettings?.enableDisabilityMode);
    const hubLanguages = useSelector(state => state.configuration?.hubSettings?.languages?.length ? state.configuration.hubSettings.languages : [] );
    const [listOpen, setListOpen] = useState(false);
    const wrapperRef = useRef(null);

    const DisabilityButton = () => {
        return (
            <div>
                <FooterButton>
                    <DisabilityMode
                        toggleDisabilityMode={toggleDisabilityMode}
                        disabilityOn={disabilityOn}
                        alterMarginTop={alterMarginTop}
                    />
                </FooterButton>
            </div>
        );
    }

    if (footerType === "hidden") {
        return null;
    }

    // Dashboard page footer
    if (footerType === "dashboard") {
        return (
            <>
                { (hubLanguages?.length > 1 || enableDisabilityMode) &&
                    <StyledFooter ref={wrapperRef}>
                        { listOpen &&
                            <LanguageSelectionList
                                hubLanguages={hubLanguages}
                                closeList={() => setListOpen(false)}
                                ignoreRef={wrapperRef}
                            />
                        }
                        <CenteredContainer>
                            <LanguageSelection
                                hubLanguages={hubLanguages}
                                toggle={() => setListOpen(prev => !prev)}
                                listOpen={listOpen}
                            />
                            { enableDisabilityMode && <DisabilityButton/> }
                        </CenteredContainer>
                    </StyledFooter>
                }
            </>
        )
    }

    // Other pages footer
    return (
        <div>
            <StyledFooter ref={wrapperRef}>
                { listOpen &&
                    <LanguageSelectionList
                        hubLanguages={hubLanguages}
                        closeList={() => setListOpen(false)}
                        ignoreRef={wrapperRef}
                    />
                }
                <CenteredContainer>
                    <div>
                        <FooterButton onClick={() => browserHistory.goBack()}>
                            { theme.altFooterBackIcon ?
                                <img width={40} alt="Back" src={theme.altFooterBackIcon}/>
                                :
                                <i className="fa fa-arrow-left"/>
                            }
                        </FooterButton>
                    </div>
                    <div>
                        <FooterButton onClick={() => browserHistory.push("/")}>
                            { theme.altFooterHomeIcon ?
                                <img width={40} alt="Home" src={theme.altFooterHomeIcon}/>
                                :
                                <i className="fa fa-home"/>
                            }
                        </FooterButton>
                    </div>
                    <div>
                        { theme.useFooterLanguageButton &&
                            <LanguageSelection
                                isIcon={true}
                                hubLanguages={hubLanguages}
                                toggle={() => setListOpen(prev => !prev)}
                                listOpen={listOpen}
                            />
                        }
                        { enableDisabilityMode && <DisabilityButton/> }
                    </div>
                </CenteredContainer>
            </StyledFooter>
        </div>
    );
};
export default Footer;